/* BD 24.09.2026 Maschine zuerst v1. Alt: BeamBuddy startet sofort. Neu: mobil nicht laden, Desktop nach bewusster Interaktion. Grund: Geräteeinstieg priorisieren. */
(function () {
  'use strict';
  var source = document.currentScript;
  if (!source || window.matchMedia('(max-width: 767px)').matches) return;
  var loaded = false;
  function load() {
    if (loaded) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;
    loaded = true;
    ['pointerdown', 'keydown', 'scroll'].forEach(function (name) { window.removeEventListener(name, load); });
    var script = document.createElement('script');
    script.src = source.getAttribute('data-bd-chat-src');
    script.dataset.api = source.getAttribute('data-api');
    script.defer = true;
    document.body.appendChild(script);
  }
  ['pointerdown', 'keydown', 'scroll'].forEach(function (name) { window.addEventListener(name, load, { passive: true }); });
})();
